import { SET_CONFIG, SET_PAGE } from './constants'

export const setConfigAction = payload => ({
  type: SET_CONFIG,
  payload,
})

export const setPage = payload => ({
  type: SET_PAGE,
  payload,
})
